export const iconFontAwesomeTravelHotelTruckPickup = (
	<i className="fa-solid fa-truck-pickup"></i>
);
